export const RQ_POST_TENANT_USER_REGISTER_API = {
  url: 'api/v1/tenant/admin/register',
  method: 'POST',
  auth: true,
  search: true,
};
export const RQ_GET_TENANTS_ADMINS_API = {
  url: 'api/v1/tenant/lookup/alladmins/search/all?',
  method: 'GET',
  auth: true,
  search:true,
};

export const RQ_PUT_UPDATE_TENANT_USER_STATUS_API = {
  url: 'api/v1/user/<%= id %>/update/status',
  method: 'PUT',
  auth: true,
  search:true,
};

export const RQ_PUT_TENANT_USER_UPDATE_API = {
  url: 'api/v1/user/<%= id %>/update/profile',
  method: 'PUT',
  auth: true,
  search: true,
};
